import React from 'react'
import Profile from '../../Reuseable/Profile'

const JuryProfile = () => {
  return (
    <>  
        <Profile />
    </>
  )
}

export default JuryProfile